<section class="dashboard_content_sec">
  <div class="dashboard_bred_crumb">
    <ul>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li [routerLink]='["../../list"]'>My Orders</li>
      <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>
      <li>View</li>
    </ul>
  </div>
  <section class="master_view_sec master_order_view_sec">
    <div class="view_box">
      <div class="order_view_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
        fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
        <div class="order_view_column order_view_column_left" fxLayout="column" fxFlex.xl="70" fxFlex.lg="70"
          fxFlex.md="70" fxFlex.sm="70" fxFlex.xs="100" fxFlexFill>
          <div class="order_view_left">
            <div class="order_status">
              <h4>
                <span class="custom_sub_heading primary">Current Order Status</span>
                <div class="d-flex view_invoice_flex">
                  <button type="button" class="btn btn-sm global-btn" mat-button (click)="changeStatus()">Update</button>
                  <button type="button" class="btn btn-sm global-btn" mat-button (click)="viewInvoice()"
                    *ngIf="oldSecondHandSuppliesOrder.status === 'DELIVERED'"> View Invoice </button>
                </div>
              </h4>
              <!-- WEB-TRACK -->
              <!-- <div class="order_track web_order_track" fxLayoutAlign="center center" fxShow="true" fxShow.lt-sm="false">
                <ul>
                  <li class="completed" *ngFor="let singleNote of oldSecondHandSuppliesOrder.supplies_order_notes">
                    <div class="title_circle_flex">
                      <span class="circles" [ngClass]="singleNote?.status"></span>
                      <h4>{{singleNote.status}}</h4>
                    </div>
                    <div class="time_invoice_flex">
                      <span class="time">
                        {{singleNote.created_at | date: 'dd-MM-yyyy hh:mm' }}
                      </span>
                    </div>
                  </li>
                </ul>
              </div> -->
              <!-- MOBILE-TRACK -->
              <div class="mobile_order_track">
                <div class="order-track" [@openCloseStatus]="openStatus ? true : false">
                  <div class="order-track-step"
                    *ngFor="let singleNote of oldSecondHandSuppliesOrder.second_hand_supplies_order_notes">
                    <div class="order-track-status">
                      <span class="order-track-status-dot" [ngClass]="singleNote?.status"></span>
                      <span class="order-track-status-line"></span>
                    </div>
                    <div class="order-track-text">
                      <p class="order-track-text-stat">{{singleNote.status}}</p>
                      <span class="order-track-text-sub">{{singleNote.created_at | date: 'dd-MM-yyyy hh:mm' }}</span>
                    </div>
                  </div>
                </div>
                <div class="view_all_status"
                  *ngIf="oldSecondHandSuppliesOrder.second_hand_supplies_order_notes.length >= 3">
                  <a (click)="filterToggleStatus()">View all status</a>
                </div>
              </div>
            </div>
            <div class="order_details">
              <div class="order_flex">
                <div class="order_head">
                  <h2>Order No : {{oldSecondHandSuppliesOrder.order_number}}</h2>
                  <h3>Order at : {{oldSecondHandSuppliesOrder.created_at | date: 'dd/MM/yyyy'}}</h3>
                </div>
                <!-- <div class="delivered_status_flex" *ngIf="oldSecondHandSuppliesOrder.status === 'CANCELLED'">
                  <div class="delivered_status cancelled">
                    <img src="../../../../../assets/images/icons/failed.svg" alt="">
                    <h5>{{oldSecondHandSuppliesOrder.status}}</h5>
                  </div>
                </div>-->
                <!-- <div class="delivered_status_flex" *ngIf="oldSecondHandSuppliesOrder.status !== 'CANCELLED'">
                  <div class="delivered_status">
                    <img src="../../../../../assets/images/icons/delivered_status.svg" alt="">
                    <h5>{{oldSecondHandSuppliesOrder.status}}</h5>
                  </div>
                </div>
                </div> -->
              </div>
              <div class="order_view_address_row" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row"
                fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="15px">
                <div class="order_view_address_column" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                  fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                  <div class="address_details">
                    <h4 class="no_border">Shipping address :</h4>
                    <div class="media">
                      <img src="../../../../../../../assets/images/icons/marker.svg" alt="">
                      <div class="address_lines">
                        <p *ngIf="oldSecondHandSuppliesOrder?.shipping_address?.short_name">
                          {{oldSecondHandSuppliesOrder?.shipping_address?.short_name}},</p>
                        <p *ngIf="oldSecondHandSuppliesOrder?.shipping_address?.line_1">
                          {{oldSecondHandSuppliesOrder?.shipping_address?.line_1}},</p>
                        <p
                          *ngIf="oldSecondHandSuppliesOrder?.shipping_address?.line_2 && oldSecondHandSuppliesOrder?.shipping_address?.landmark">
                          {{oldSecondHandSuppliesOrder?.shipping_address?.line_2}},
                          {{oldSecondHandSuppliesOrder?.shipping_address?.landmark}},</p>
                        <p
                          *ngIf="oldSecondHandSuppliesOrder?.shipping_address?.city && oldSecondHandSuppliesOrder?.shipping_address?.state && oldSecondHandSuppliesOrder?.shipping_address?.postal_code">
                          {{oldSecondHandSuppliesOrder?.shipping_address?.city}},
                          {{oldSecondHandSuppliesOrder?.shipping_address?.state}},
                          {{oldSecondHandSuppliesOrder?.shipping_address?.postal_code}}</p>
                        <p *ngIf="oldSecondHandSuppliesOrder?.shipping_address?.country">
                          {{oldSecondHandSuppliesOrder?.shipping_address?.country}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="order_view_address_column" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50"
                  fxFlex.sm="50" fxFlex.xs="100" fxFlexFill>
                  <div class="address_details br-0">
                    <h4>Customer Info :</h4>
                    <div class="media" *ngIf="oldSecondHandSuppliesOrder.dental_practice">
                      <!-- <img src="../../../../../../../assets/images/icons/marker.svg" alt=""> -->
                      <div class="address_lines">
                        <p>{{oldSecondHandSuppliesOrder.dental_practice.name}}</p>
                        <p>{{oldSecondHandSuppliesOrder.dental_practice.phone}}</p>
                        <p>{{oldSecondHandSuppliesOrder.dental_practice.email}}</p>
                      </div>
                    </div>
                    <div class="media" *ngIf="oldSecondHandSuppliesOrder.dental_professional">
                      <!-- <img src="../../../../../../../assets/images/icons/marker.svg" alt=""> -->
                      <div class="address_lines">
                        <p>{{oldSecondHandSuppliesOrder.dental_professional.name}}</p>
                        <p>{{oldSecondHandSuppliesOrder.dental_professional.phone}}</p>
                        <p>{{oldSecondHandSuppliesOrder.dental_professional.email}}</p>
                      </div>
                    </div>
                    <div class="media" *ngIf="oldSecondHandSuppliesOrder.dental_supplier">
                      <!-- <img src="../../../../../../../assets/images/icons/marker.svg" alt=""> -->
                      <div class="address_lines">
                        <p>{{oldSecondHandSuppliesOrder.dental_supplier.name}}</p>
                        <p>{{oldSecondHandSuppliesOrder.dental_supplier.phone}}</p>
                        <p>{{oldSecondHandSuppliesOrder.dental_supplier.email}}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <!--<div class="order_view_address_column" fxLayout="column" fxFlex.xl="50" fxFlex.lg="50" fxFlex.md="50" fxFlex.sm="50" fxFlex.xs="100"
                  fxFlexFill>
                  <div class="address_details">
                    <h4 class="no_border">Billing Address :</h4>
                    <div class="media">
                      <img src="../../../../../../../assets/images/icons/marker.svg" alt="">
                      <div class="address_lines">
                        <p>{{oldSecondHandSuppliesOrder?.billing_address?.short_name}},
                          {{oldSecondHandSuppliesOrder?.billing_address?.line_1}},
                          {{oldSecondHandSuppliesOrder?.billing_address?.line_2}},
                          {{oldSecondHandSuppliesOrder?.billing_address?.landmark}},
                          {{oldSecondHandSuppliesOrder?.billing_address?.city}},
                          {{oldSecondHandSuppliesOrder?.billing_address?.state}},
                          {{oldSecondHandSuppliesOrder?.billing_address?.country}}
                          -
                          {{oldSecondHandSuppliesOrder?.billing_address?.postal_code}}</p>
                      </div>
                    </div>
                  </div>
                </div>-->
              </div>
            </div>
            <div class="order_items_liting">
              <div class="order-product-listing">
                <ul>
                  <li>
                    <div class="cart_box_li">
                    <div class="media">
                      <div class="media-left">
                        <img [src]="oldSecondHandSuppliesOrder?.second_hand_supply?.image?.url" class="media-object">
                      </div>
                      <div class="media-body">
                        <h4 class="media-heading">{{oldSecondHandSuppliesOrder.second_hand_supply.title}}</h4>
                        <div class="custom_form_group">
                          <label for="" class="custom_label w-auto">Quantity <span class="dots pr-5">:</span></label>
                          <p class="value">1</p>
                        </div>
                        <div class="custom_form_group">
                          <label for="" class="custom_label w-auto">price <span class="dots pr-5">:</span> </label>
                          <p class="value">AUD {{oldSecondHandSuppliesOrder?.sub_total.toFixed(2)}}</p>
                        </div>
                        <div class="custom_form_group" *ngIf="oldSecondHandSuppliesOrder.second_hand_supply.color">
                          <label for="" class="custom_label w-auto">Color <span class="dots pr-5">:</span> </label>
                          <p class="value">
                            <span class="colorBox" [ngStyle]="{
                              'background-color': oldSecondHandSuppliesOrder?.second_hand_supply?.color,
                            'border-color': oldSecondHandSuppliesOrder?.second_hand_supply?.color }">
                            </span>
                          </p>
                        </div>
                        <!-- <h5><span>Quantity :</span> 1 </h5> -->
                        <!-- <h5 *ngIf="oldSecondHandSuppliesOrder?.second_hand_supply?.color"><span>Color :</span>
                          <span class="colorBox" [ngStyle]="{
                            'background-color': oldSecondHandSuppliesOrder?.second_hand_supply?.color,
                          'border-color': oldSecondHandSuppliesOrder?.second_hand_supply?.color }">
                          </span>
                        </h5> -->
                        <!-- <div class="price">
                          <div class="price_box_flex">
                            <span class="price_overall">
                              AUD {{oldSecondHandSuppliesOrder?.sub_total.toFixed(2)}}
                            </span>
                          </div>
                        </div> -->
                      </div>
                    </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="order_view_column order_view_column_right" fxLayout="column" fxFlex.xl="30" fxFlex.lg="30"
          fxFlex.md="30" fxFlex.sm="30" fxFlex.xs="100" fxFlexFill>
          <div class="order_view_right">
            <div class="order_price_details">
              <div class="payment_head">
                <h2>Amount Paid : AUD {{oldSecondHandSuppliesOrder.total_amount.toFixed(2)}}</h2>
                <h3>Mode of payment : {{oldSecondHandSuppliesOrder.payment_mode}}</h3>
                <!--<h3>Transaction Id : #12345678</h3>-->
              </div>
              <div class="total-cost-box">
                <div class="total-cost">
                  <span class="total-text">Subtotal</span>
                  <span class="total-price">
                    AUD {{oldSecondHandSuppliesOrder.sub_total.toFixed(2)}}
                  </span>
                </div>
                <div class="total-cost">
                  <span class="total-text">Freight Charges</span>
                  <span class="total-price">
                    {{oldSecondHandSuppliesOrder.delivery_charge.toFixed(2)}}
                  </span>
                </div>
                <div class="total-cost">
                  <span class="total-text">GST</span>
                  <span class="total-price">
                    AUD {{oldSecondHandSuppliesOrder.tax_amount.toFixed(2)}}
                  </span>
                </div>
                <div class="total-cost final_amount">
                  <span class="total-text">Total Payable</span>
                  <span class="total-price">
                    AUD {{oldSecondHandSuppliesOrder.total_amount.toFixed(2)}}
                  </span>
                </div>
              </div>
              <div>
                <!--<button class="bnt btn-sm global-btn mat-button cancel_order" mat-button
                  *ngIf="oldSecondHandSuppliesOrder.status === 'PENDING'" (click)="cancelOrder()">Cancel
                  Order</button>-->
              </div>
            </div>
            <div class="delivery_notes">
              <div class="head">
                <h4>Delivery Note</h4>
              </div>
              <ul>
                <li *ngFor="let singleNote of oldSecondHandSuppliesOrder?.second_hand_supplies_order_notes">
                  <div class="notes_content">
                    <p>{{singleNote.message}} </p>
                    <p *ngIf="singleNote?.extra?.tracking_number">Tracking Number:
                      {{singleNote?.extra?.tracking_number}} </p>
                    <p *ngIf="singleNote?.extra?.freight_company_name">{{singleNote?.extra?.freight_company_name}} </p>
                    <div class="flex_btns_track">
                      <p *ngIf="singleNote?.extra?.invoice?.url">
                        <a target="_blank" [href]="singleNote?.extra?.invoice?.url">View
                          and Download Invoice </a>
                      </p>
                      <p *ngIf="singleNote?.extra?.tracking_link">
                        <a target="_blank" [href]="singleNote?.extra?.tracking_link">Track </a>
                      </p>
                    </div>
                  </div>
                  <p class="status">Status :{{singleNote.created_at | date:'hh:mm dd MMM yyyy' }} ,
                    {{singleNote.status}}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</section>
